import {
	CLEAR_INVESTOR_STATE,
	GET_INVESTOR_REQUEST,
	GET_INVESTOR_SUCCESS,
	GET_INVESTOR_ERROR,
	CLEAR_INVESTOR_LIST,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const INVESTOR_URL = '/investor/list';

const defaultState = () => ({
	investorList: [],
	isLoadingInvestor: '',
});

const state = defaultState();

const getters = {
	investorList: (state) => state.investorList,
	isLoadingInvestor: (state) => state.isLoadingInvestor === 'loading',
};

const mutations = {
	[CLEAR_INVESTOR_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_INVESTOR_REQUEST]: (state) => {
		state.isLoadingInvestor = 'loading';
	},
	[GET_INVESTOR_SUCCESS]: (state, data) => {
		if (data.length) {
			state.investorList = data.sort((a, b) => {
				const textA = a.name.toUpperCase();
				const textB = b.name.toUpperCase();
				return textA < textB ? -1 : textA > textB ? 1 : 0;
			});
		}
		state.isLoadingInvestor = 'success';
	},
	[GET_INVESTOR_ERROR]: (state) => {
		state.investorList = [];
		state.isLoadingInvestor = 'error';
	},
	[CLEAR_INVESTOR_LIST]: (state) => {
		state.investorList = [];
	},
};

const actions = {
	[GET_INVESTOR_REQUEST]: async ({ commit }, { params, vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_INVESTOR_REQUEST);
			let url = INVESTOR_URL;

			if (params) {
				url = `${INVESTOR_URL}?${params}`;
			}

			http({
				method: 'GET',
				url: url,
			})
				.then((response) => {
					resolve(response);
					commit(GET_INVESTOR_SUCCESS, response.data.investors);
				})
				.catch((error) => {
					reject(error);
					commit(GET_INVESTOR_ERROR);
				});
		});
	},
	[CLEAR_INVESTOR_LIST]: ({ commit }) => {
		commit(CLEAR_INVESTOR_LIST);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
